import { FuseNavigationItem } from '@fuse/components/navigation';

export const epacNavigation: FuseNavigationItem = {
    id      : 'epac',
    title   : 'Epac',
    type    : 'collapsable',
    icon    : 'heroicons_outline:tag',
    meta : {
        permission: 'epac.access',
    },
    children: [
        {
            id   : 'licenses',
            title: 'License',
            type : 'basic',
            icon : 'mat_outline:list',
            link : '/epac/license',
        },
        {
            id   : 'forms',
            title: 'Form',
            type : 'basic',
            icon : 'mat_outline:description',
            link : '/epac/form',
        },
    ],
};
